import { isMultiTenant } from "@/Configs/config";
import { ModeSwitchIcon } from "@/Icons/v2/ModeSwitch";
import { SidebarToggleIcon } from "@/Icons/v2/SidebarIcons/SidebarToggle";
import { OutstandingPaymentsBanner } from "@/UI/Header/components/OutstandingPaymentsBanner";
import UserButton from "@/UI/Header/components/UserButton";
import { useSelectedSite } from "@/api/hooks/useSelectedSite";
import { CLIPPED_BUTTON_STYLE } from "@/constants/general";
import { useConfigService } from "@/pages/configuration/useConfigService";
import { useTrans } from "@/translations";

import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import { twMerge } from "tailwind-merge";

type Props = {
  collapsedSidebar: boolean;
  onOpenMobileNav: () => void;
};

export const HeaderRE: React.FC<Props> = ({
  collapsedSidebar,
  onOpenMobileNav,
}) => {
  const { t } = useTrans();
  const { terminalConfig } = useConfigService();
  const { selectedSite } = useSelectedSite();

  const sitePath = useMemo(() => {
    let path = "";

    if (isMultiTenant && selectedSite?.siteName) {
      path = `/${selectedSite.siteName}`;
    }

    return path;
  }, [selectedSite]);

  const currentPath = window.location.pathname.split("/")?.[2];

  const showHomePageModeSwitch = useMemo(
    () => ["", "classic"].includes(currentPath),
    [currentPath],
  );

  const buttonTextKey = useMemo(() => {
    if (currentPath === "") {
      return "common:switchHomePageClassic";
    }

    if (currentPath === "classic") {
      return "common:switchHomePageNew";
    }

    return "";
  }, [currentPath]);

  const buttonPathName = useMemo(() => {
    if (currentPath === "") {
      return `${sitePath}/classic`;
    }

    if (currentPath === "classic") {
      return `${sitePath}/`;
    }

    return "";
  }, [currentPath, sitePath]);

  return (
    <div
      className={twMerge(
        "fixed top-0 right-0 z-20 flex h-16 min-h-16 w-full items-center justify-between bg-white px-4 sm:px-8",
        collapsedSidebar ? "w-[calc(100%-55px)]" : "w-[calc(100%-210px)]",
        "max-[750px]:w-full",
      )}
    >
      {terminalConfig?.hasOutstandingPayments && <OutstandingPaymentsBanner />}
      <button
        onClick={onOpenMobileNav}
        className="hidden max-[750px]:inline-flex"
        aria-label="Open navigation"
      >
        <SidebarToggleIcon />
      </button>
      <div className="max-[750px]:hidden" />
      <div className="flex items-center gap-4">
        {showHomePageModeSwitch && (
          <Link
            to={{
              pathname: buttonPathName,
            }}
            className={twMerge(
              "border-grey2 flex h-[35px] items-center gap-[7px] border border-1 px-[14px] py-[8px] text-[12.5px]",
              CLIPPED_BUTTON_STYLE,
            )}
          >
            <ModeSwitchIcon />
            {t(buttonTextKey)}
          </Link>
        )}
        <UserButton />
      </div>
    </div>
  );
};

export default HeaderRE;
